export const allLanguages: string[] = ["English", "Spanish", "Chinese", "Russian"];
